import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export const ShowPurchaseOrder = (permissions: IPermissionProps) => {
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    return (
        <>
            <Table permissions={permissions} toast={toast} reload={reload} setReload={setReload} ></Table>
            <Toast ref={toast} />
        </>
    );
}
